import {useMutation} from '@tanstack/react-query';
import {patchAuthRequestStatus} from '../../services/patchAuthRequestStatus';
import {PatchAuthRequestStatusParams} from './types';

export const usePatchAuthRequestStatusMutation = () =>
	useMutation({
		mutationFn: ({
			nuControle,
			observacoes,
			nomeOperador,
			emailOperador,
			documentoOperador,
			signal,
		}: PatchAuthRequestStatusParams) =>
			patchAuthRequestStatus(
				nuControle,
				{
					observacoes,
					nomeOperador,
					emailOperador,
					documentoOperador,
				},
				signal,
			),
	});
